import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit} from '@angular/core';
import {UserSetting} from '../../models/user-setting';
import {DOCUMENT} from '@angular/common';
import {SharedValueService} from '../../services/shared-value.service';
import {DialogService} from '../../services/dialog.service';
import {Router} from '@angular/router';
import {DialogResult} from '../../models/dialog-param';
import {UserService} from '../../services/user.service';
import {NotifierService} from 'angular-notifier';
import {AuthenticationService} from '../../services/authentication.service';
import set = Reflect.set;
import {Subscription} from 'rxjs/Rx';
declare const $: any;

@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
  preserveWhitespaces: false
})
export class SiteHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  userSession: UserSetting;
  isFullScreen = false;
  private retryTime = 500;
  defaultAvatar = '/assets/img/user.png';
  userAvatar: string;
  subscription: Subscription;

  constructor(@Inject(DOCUMENT) private document: any,
              private sharedValueService: SharedValueService,
              private diaglog: DialogService,
              private router: Router,
              private userService: UserService,
              private notify: NotifierService,
              private _eleRef: ElementRef,
              private authen: AuthenticationService) { }

  ngOnInit() {
    this.userSession = this.sharedValueService.getUserSession();
    if (! this.userSession) {
      setTimeout(() => {
       this.sharedValueService.fetchUserSession().subscribe(user => {
         this.userSession = this.sharedValueService.getUserSession();
         this.userAvatar = this.userSession.avatar;
       });
      }, this.retryTime);
      return;
    } else {
      this.userAvatar = this.userSession.avatar;
    }
    this.subscription = this.sharedValueService.getAvatar().subscribe(avatar => {
      this.userAvatar = avatar;
    });
  }

  ngAfterViewInit() {
    let topbar_open = 0, nav_open = 0;
    const topbarElement = this._eleRef.nativeElement.querySelector('.topbar-toggler');
    const sidenavElement = this._eleRef.nativeElement.querySelector('.sidenav-toggler');

    $(topbarElement).on('click', (e) => {
      if (topbar_open === 1) {
        $('html').removeClass('topbar_open');
        $(topbarElement).removeClass('toggled');
        topbar_open = 0;
      } else {
        $('html').addClass('topbar_open');
        $(topbarElement).addClass('toggled');
        topbar_open = 1;
      }
    });

    $(sidenavElement).on('click', () => {
      if (nav_open === 1) {
        $('html').removeClass('nav_open');
        $(sidenavElement).removeClass('toggled');
        nav_open = 0;
      }  else {
        $('html').addClass('nav_open');
        $(sidenavElement).addClass('toggled');
        nav_open = 1;
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  setDefaultAvatar() {
    this.userAvatar = this.defaultAvatar;
  }

  toggle_fullscreen(event: any) {
    if (event) {
      const fullscreenEnabled = this.document.fullscreenEnabled || this.document['mozFullScreenEnabled'] ||
        this.document.webkitFullscreenEnabled;
      if (fullscreenEnabled) {
        if (!this.document.fullscreenElement && !this.document['mozFullScreenElement'] && !this.document.webkitFullscreenElement &&
          !this.document['msFullscreenElement']) {
          this.isFullScreen = true;
          this.launchIntoFullscreen(this.document.documentElement);
        } else {
          this.isFullScreen = false;
          this.exitFullscreen();
        }
      }
    }
  }

  launchIntoFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  exitFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    }
  }

  clickLogOut() {
    this.diaglog.showMessage('Logout Confirmation', 'Are you sure want to logout from this awesome system?', null,
      'Yes, I\'m sure', null, null, 'No!').subscribe((res) => {
      if (res.isOk()) {
        setTimeout(() => {
          this.diaglog.setLoaderVisible(true);
        });
        this.authen.logout().subscribe(response => {
          setTimeout(() => {
            this.diaglog.setLoaderVisible(false);
          });
          this.router.navigate(['/logout', {replaceUrl: true}]);
        }, error => {
          setTimeout(() => {
            this.diaglog.setLoaderVisible(false);
          });
          this.router.navigate(['/logout', {replaceUrl: true}]);
        });
      }
    });
  }
  showProfileModal() {
    const obj = {
      isAPICallError: false,
      checkValidate: true,
      model: this.userSession
    };
    this.diaglog.showUserProfileModal('Profile', obj).subscribe();
  }

  showChangePassModal() {
    const obj = {
      isAPICallError: false,
      checkValidate: true,
      model: {password: '', confirm_password: ''}
    };
    this.diaglog.showChangePasswordModal('Change Password', obj)
      .subscribe((res: DialogResult) => {
        if (res.isOk()) {
          const _model = res.payload.model;
          this.userService.changePassword(_model).subscribe(response => {
            this.sharedValueService.httpStatus.next(true);
            this.notify.notify('success', response.message);
          }, error => {
            this.sharedValueService.httpStatus.next(false);
            const message = error.body ? error.body.message : 'Error occurred!';
            this.notify.notify('error', message);
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/layouts/site-header/site-header.component.ts